import { render, staticRenderFns } from "./InvestmentsKoopAccount.vue?vue&type=template&id=100c951c&scoped=true"
import script from "./InvestmentsKoopAccount.vue?vue&type=script&lang=js"
export * from "./InvestmentsKoopAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100c951c",
  null
  
)

export default component.exports